import { render, staticRenderFns } from "./TabTokenItemMobile.vue?vue&type=template&id=7a3332d6"
import script from "./TabTokenItemMobile.vue?vue&type=script&lang=js"
export * from "./TabTokenItemMobile.vue?vue&type=script&lang=js"
import style0 from "./TabTokenItemMobile.vue?vue&type=style&index=0&id=7a3332d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports